/**
 * Reviews page — proof wall. Figma 875:86.
 *
 * Talks to the same public Trustoo endpoints the app's own widget calls, which is
 * how sections/product-reviews.liquid already works. is_show_all=1 with no
 * product_id makes them store-wide.
 *
 * Sort and the photos filter are SERVER side (a refetch from page 1) because the
 * API owns the ordering across all 5,013 reviews. Search and the category pills
 * are CLIENT side over what has been loaded, so the result line says so rather
 * than implying it searched everything.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-reviews-proof-wall]');
  if (!root) return;

  var SHOP = root.getAttribute('data-shop-id');
  var PAGE_SIZE = parseInt(root.getAttribute('data-page-size'), 10) || 24;
  var REVIEWS = 'https://api.trustoo.io/api/v1/reviews/get_product_reviews';
  var RATING = 'https://rapi.trustoo.io/api/v1/product/customer/get_rating';

  var grid = root.querySelector('[data-rpw-grid]');
  var mosaic = root.querySelector('[data-rpw-mosaic]');
  var moreBtn = root.querySelector('[data-rpw-more]');
  var emptyEl = root.querySelector('[data-rpw-empty]');
  var resultEl = root.querySelector('[data-rpw-result]');
  var resultText = root.querySelector('[data-rpw-result-text]');
  var clearBtn = root.querySelector('[data-rpw-clear]');
  var searchEl = root.querySelector('[data-rpw-search]');
  var sortWrap = root.querySelector('[data-rpw-sort-wrap]');
  var sortBtn = root.querySelector('[data-rpw-sort-btn]');
  var sortMenu = root.querySelector('[data-rpw-sort-menu]');
  var sortValueEl = root.querySelector('[data-rpw-sort-value]');

  /* The frame's five options, node 894:86.

     Trustoo sorts by date and by star and by nothing else, so Most helpful and
     With photos first are ordered here instead. That orders what has LOADED, not
     all 5,013, which is the honest limit of doing it client side and the reason
     the count line keeps saying how many are loaded. */
  var SORTS = {
    'recent':    { server: 'commented-at-descending', label: 'Most recent' },
    'star-desc': { server: 'star-descending',         label: 'Highest rated' },
    'star-asc':  { server: 'star-ascending',          label: 'Lowest rated' },
    'helpful':   { server: 'commented-at-descending', label: 'Most helpful',
                   local: function (a, b) { return (Number(b.likes_count) || 0) - (Number(a.likes_count) || 0); } },
    'photos':    { server: 'commented-at-descending', label: 'With photos first',
                   local: function (a, b) { return ((b.resources || []).length ? 1 : 0) - ((a.resources || []).length ? 1 : 0); } }
  };
  var pills = Array.prototype.slice.call(root.querySelectorAll('[data-rpw-pill]'));

  var state = { page: 1, totalPages: 1, totalCount: 0, loading: false,
                photosOnly: false, catIds: null, query: '', star: null, deepening: false,
                sort: 'recent', loaded: [] };

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function num(n) { return Number(n || 0).toLocaleString('en-CA'); }

  function stars(n) {
    var out = '';
    for (var i = 1; i <= 5; i++) {
      out += '<svg class="rpw-star' + (i <= n ? '' : ' rpw-star--empty') +
        '" viewBox="0 0 24 24" width="13" height="13" aria-hidden="true">' +
        '<path d="m12 2.6 2.9 5.9 6.5.9-4.7 4.6 1.1 6.4-5.8-3-5.8 3 1.1-6.4L2.6 9.4l6.5-.9z"/></svg>';
    }
    return '<span class="rpw-stars" role="img" aria-label="' + n + ' out of 5 stars">' + out + '</span>';
  }

  function initials(name) {
    var parts = String(name || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return '?';
    return (parts[0][0] + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase();
  }

  function niceDate(raw) {
    var d = new Date(String(raw || '').replace(' ', 'T'));
    if (isNaN(d)) return '';
    return d.toLocaleDateString('en-CA', { day: 'numeric', month: 'short', year: 'numeric' });
  }

  function query(extra) {
    var p = ['shop_id=' + encodeURIComponent(SHOP), 'scene=1', 'is_show_all=1',
             'limit=' + PAGE_SIZE,
             'sort_by=' + encodeURIComponent((SORTS[state.sort] || SORTS.recent).server)];
    if (state.photosOnly) { p.push('has_resource=1', 'no_empty=2', 'is_buyers_show=2'); }
    return p.concat(extra || []).join('&');
  }

  function card(r) {
    var photo = (r.resources || [])[0];
    var prod = r.corresponding_product;
    var html = '<article class="rpw-card">';
    html += '<div class="rpw-card-top">' + stars(r.star) +
            '<span class="rpw-card-date">' + esc(niceDate(r.commented_at)) + '</span></div>';
    if (photo && photo.src) {
      html += '<button type="button" class="rpw-card-photo" data-rpw-card-photo="' + esc(r.id) +
              '" aria-label="Open photo"><img src="' + esc(photo.src) + '" alt="" loading="lazy" decoding="async"></button>';
    }
    if (r.content) html += '<p class="rpw-card-text">' + esc(r.content) + '</p>';
    if (prod && prod.product_name) {
      html += '<a class="rpw-card-product" href="' + esc(prod.product_url || '#') + '">' +
        (prod.product_image ? '<img src="' + esc(prod.product_image) + '" alt="" loading="lazy">' : '<img alt="">') +
        '<span class="rpw-card-product-name">' + esc(prod.product_name) + '</span></a>';
    }
    html += '<div class="rpw-card-author"><span class="rpw-avatar">' + esc(initials(r.author)) + '</span>' +
            '<span class="rpw-author-name">' + esc(r.author || 'Anonymous') + '</span>' +
            (Number(r.verified_badge) ? '<span class="rpw-verified">Verified</span>' : '') + '</div>';
    return html + '</article>';
  }

  /* Category and search narrow what is already loaded. Kept separate from the
     server filters so the result line can be honest about which is which. */
  function visible() {
    var q = state.query.toLowerCase();
    return state.loaded.filter(function (r) {
      if (state.star && Number(r.star) !== state.star) return false;
      if (state.catIds) {
        var pid = r.corresponding_product && String(r.corresponding_product.product_id);
        if (!pid || state.catIds.indexOf(pid) === -1) return false;
      }
      if (q) {
        var hay = ((r.content || '') + ' ' + (r.author || '') + ' ' +
          ((r.corresponding_product && r.corresponding_product.product_name) || '')).toLowerCase();
        if (hay.indexOf(q) === -1) return false;
      }
      return true;
    });
  }

  function paint() {
    var rows = visible();
    var chosen = SORTS[state.sort];
    if (chosen && chosen.local) rows = rows.slice().sort(chosen.local);
    grid.innerHTML = rows.map(card).join('');
    grid.setAttribute('aria-busy', 'false');
    emptyEl.hidden = rows.length > 0;

    var filtering = state.photosOnly || state.catIds || state.query || state.star;
    resultEl.hidden = !filtering;
    if (filtering) {
      var what = state.photosOnly ? ' reviews with photos' : ' reviews';
      var narrowed = state.catIds || state.query || state.star;
      resultText.textContent = narrowed
        ? 'Showing ' + num(rows.length) + ' of ' + num(state.loaded.length) + ' loaded' + what +
          (state.star ? ' at ' + state.star + ' star' : '')
        : 'Showing ' + num(rows.length) + ' of ' + num(state.totalCount) + what;
    }
    /* The frame does not just say the combination is empty, it says WHY, using the
       real numbers: "Only nine people have left a one star review, and none of them
       added a photo." Built from what is actually known rather than a fixed string,
       so it cannot claim a count that is not true. */
    var bodyEl = root.querySelector('[data-rpw-empty-body]');
    if (bodyEl && !rows.length) {
      var atStar = state.star
        ? state.loaded.filter(function (r) { return Number(r.star) === state.star; }).length
        : 0;
      var why = [];
      if (state.star) {
        why.push('Only ' + num(atStar) + ' of the reviews loaded so far are ' + state.star + ' star');
      }
      if (state.photosOnly) why.push('none of those added a photo');
      if (state.query) why.push('nothing loaded mentions "' + state.query + '"');
      bodyEl.textContent = why.length
        ? why.join(', and ') + '. Try widening the rating or clearing the photo filter.'
        : 'Try widening the rating or clearing the photo filter.';
    }
    var showAll = root.querySelector('[data-rpw-showall]');
    if (showAll) showAll.hidden = !state.star;
    /* A rating with few reviews needs depth before it can show anything, so
       pull more pages rather than leaving an empty grid under a clicked bar. */
    if (state.star && rows.length < 6 && state.page < state.totalPages && !state.deepening) {
      state.deepening = true;
      state.page++;
      load(false, true);
    }
    if (moreBtn) moreBtn.hidden = state.page >= state.totalPages;
    var countEl = root.querySelector('[data-rpw-count]');
    if (countEl) {
      countEl.hidden = !state.loaded.length;
      countEl.textContent = num(rows.length) + ' of ' + num(state.totalCount) + ' shown';
    }
  }

  /* ST4, node 894:168: the label is replaced by a spinner and the word Loading,
     in place, with the count line left showing underneath. */
  function setMoreLoading(on) {
    if (!moreBtn) return;
    var spin = moreBtn.querySelector('[data-rpw-spinner]');
    var label = moreBtn.querySelector('[data-rpw-more-label]');
    if (spin) spin.hidden = !on;
    if (label) label.textContent = on ? 'Loading' : (moreBtn.dataset.rpwLabel || 'Load 24 more');
    moreBtn.disabled = !!on;
  }

  function load(reset, deep) {
    if (state.loading) return;
    state.loading = true;
    if (reset) { state.page = 1; state.loaded = []; grid.setAttribute('aria-busy', 'true'); }
    /* Setting textContent here would delete the spinner and the label span the
       button is built from, so the button could never show Loading twice. */
    setMoreLoading(true);

    fetch(REVIEWS + '?' + query(['page=' + state.page]), { headers: { accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var d = (j && j.data) || {};
        var list = d.list || [];
        state.totalPages = (d.page && d.page.total_page) || 1;
        state.totalCount = (d.page && d.page.count) || list.length;
        state.loaded = state.loaded.concat(list);
        paint();
      })
      .catch(function () {
        grid.setAttribute('aria-busy', 'false');
        if (!state.loaded.length) {
          grid.innerHTML = '';
          emptyEl.hidden = false;
          var eb = emptyEl.querySelector('[data-rpw-empty-body]');
          if (eb) eb.textContent = 'Reviews could not be loaded just now. Please refresh.';
        }
      })
      .finally(function () {
        state.loading = false;
        setMoreLoading(false);
        state.deepening = false;
        if (moreBtn) moreBtn.textContent = 'Load more reviews';
      });
  }

  /* Summary numbers are already painted from section settings, so this only
     corrects them. It never blanks the hero if the request fails. */
  function loadSummary() {
    fetch(RATING + '?shop_id=' + encodeURIComponent(SHOP) + '&is_all_products_rating=1',
      { headers: { accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var d = (j && j.data) || {};
        if (!d.total_reviews) return;
        var avg = root.querySelector('[data-rpw-average]');
        var tot = root.querySelector('[data-rpw-total]');
        if (avg && d.rating) avg.textContent = Number(d.rating).toFixed(1);
        if (tot) tot.textContent = num(d.total_reviews);
        var max = Math.max(d.total_star1, d.total_star2, d.total_star3, d.total_star4, d.total_star5) || 1;
        for (var s = 1; s <= 5; s++) {
          var row = root.querySelector('[data-rpw-bar="' + s + '"]');
          if (!row) continue;
          var n = Number(d['total_star' + s]) || 0;
          row.querySelector('.rpw-bar-count').textContent = num(n);
          row.querySelector('.rpw-bar-fill').style.width = (n / max * 100) + '%';
        }
      })
      .catch(function () { /* settings values stand */ });
  }

  function loadPhotos() {
    fetch(REVIEWS + '?shop_id=' + encodeURIComponent(SHOP) +
          '&scene=1&is_show_all=1&is_buyers_show=2&has_resource=1&no_empty=2&limit=24&page=1' +
          '&sort_by=commented-at-descending', { headers: { accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var d = (j && j.data) || {};
        var list = (d.list || []).filter(function (r) { return (r.resources || []).length; });
        var total = (d.page && d.page.count) || list.length;
        var totalEl = root.querySelector('[data-rpw-photo-total]');
        if (totalEl) totalEl.textContent = num(total);
        if (!list.length) { mosaic.closest('.rpw-band').hidden = true; return; }
        photos.items = list.slice();
        photos.total = total;
        photos.page = 1;
        /* The frame keeps FIVE photos and puts a pill on the last one. It does
           not replace a photo with a navy count block: the tile stays a real
           customer photo and the pill floats over it, so the mosaic reads as five
           rooms rather than four rooms and a button. */
        var shown = list.slice(0, 5);
        var html = shown.map(function (r, i) {
          var last = i === shown.length - 1 && total > shown.length;
          return '<button type="button" class="rpw-tile' + (last ? ' rpw-tile--all' : '') +
                 '" data-rpw-photo="' + i + '" aria-label="' +
                 (last ? 'View all ' + num(total) + ' photos' : 'Open photo ' + (i + 1)) + '">' +
                 '<img src="' + esc(r.resources[0].src) + '" alt="" loading="lazy" decoding="async">' +
                 (last ? '<span class="rpw-tile-pill">View all ' + num(total) + ' photos</span>' : '') +
                 '</button>';
        }).join('');
        mosaic.innerHTML = html;
        mosaic.setAttribute('aria-busy', 'false');
      })
      .catch(function () { if (mosaic) mosaic.closest('.rpw-band').hidden = true; });
  }

  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      var on = pill.getAttribute('aria-pressed') === 'true';
      var kind = pill.getAttribute('data-rpw-pill');
      if (kind === 'photos') {
        pill.setAttribute('aria-pressed', on ? 'false' : 'true');
        state.photosOnly = !on;
        syncUrl();
        load(true);                       /* server side, so refetch */
        return;
      }
      pills.forEach(function (p) {
        if (p.getAttribute('data-rpw-pill') === 'cat') p.setAttribute('aria-pressed', 'false');
      });
      if (on) { state.catIds = null; }
      else {
        pill.setAttribute('aria-pressed', 'true');
        state.catIds = (pill.getAttribute('data-rpw-ids') || '').split(',').filter(Boolean);
      }
      paint();
    });
  });

  Array.prototype.forEach.call(root.querySelectorAll('[data-rpw-bar]'), function (bar) {
    bar.addEventListener('click', function () {
      var v = parseInt(bar.getAttribute('data-rpw-bar'), 10);
      var on = bar.getAttribute('aria-pressed') === 'true';
      Array.prototype.forEach.call(root.querySelectorAll('[data-rpw-bar]'), function (b) {
        b.setAttribute('aria-pressed', 'false');
      });
      state.star = on ? null : v;
      if (!on) bar.setAttribute('aria-pressed', 'true');
      state.deepening = false;
      paint();
      syncUrl();
    });
  });

  /* Load more replaces infinite scroll, so there is an end — and the filter has
     to survive the trip, which means it lives in the URL. */
  function syncUrl() {
    var p = new URLSearchParams(window.location.search);
    state.star ? p.set('rating', state.star) : p.delete('rating');
    state.photosOnly ? p.set('photos', '1') : p.delete('photos');
    state.query ? p.set('q', state.query) : p.delete('q');
    var qs = p.toString();
    history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : ''));
  }

  function readUrl() {
    var p = new URLSearchParams(window.location.search);
    var r = parseInt(p.get('rating'), 10);
    if (r >= 1 && r <= 5) {
      state.star = r;
      var bar = root.querySelector('[data-rpw-bar="' + r + '"]');
      if (bar) bar.setAttribute('aria-pressed', 'true');
    }
    if (p.get('photos') === '1') {
      state.photosOnly = true;
      var pill = root.querySelector('[data-rpw-pill="photos"]');
      if (pill) pill.setAttribute('aria-pressed', 'true');
    }
    if (p.get('q')) { state.query = p.get('q'); if (searchEl) searchEl.value = state.query; }
  }

  var widenBtn = root.querySelector('[data-rpw-showall]');
  if (widenBtn) widenBtn.addEventListener('click', function () {
    state.star = null;
    Array.prototype.forEach.call(root.querySelectorAll('[data-rpw-bar]'), function (b) {
      b.setAttribute('aria-pressed', 'false');
    });
    paint(); syncUrl();
  });

  if (searchEl) {
    var t;
    searchEl.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(function () { state.query = searchEl.value.trim(); paint(); syncUrl(); }, 200);
    });
  }
  /* ST2, node 894:86. */
  function closeSort() {
    if (!sortMenu || !sortBtn) return;
    sortMenu.hidden = true;
    sortBtn.setAttribute('aria-expanded', 'false');
  }
  if (sortBtn && sortMenu) {
    sortBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = sortMenu.hidden;
      sortMenu.hidden = !open;
      sortBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', function (e) {
      if (sortWrap && !sortWrap.contains(e.target)) closeSort();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSort();
    });
    Array.prototype.forEach.call(sortMenu.querySelectorAll('[data-rpw-sort-opt]'), function (opt) {
      opt.addEventListener('click', function () {
        state.sort = opt.getAttribute('data-rpw-sort-opt');
        Array.prototype.forEach.call(sortMenu.querySelectorAll('[data-rpw-sort-opt]'), function (o) {
          o.setAttribute('aria-selected', o === opt ? 'true' : 'false');
        });
        if (sortValueEl) sortValueEl.textContent = (SORTS[state.sort] || SORTS.recent).label;
        closeSort();
        /* A date or star order is the server's to decide, so those refetch. The two
           local orders already have their rows and only need repainting. */
        if ((SORTS[state.sort] || {}).local) paint(); else load(true);
      });
    });
  }
  if (moreBtn) {
    moreBtn.dataset.rpwLabel = (moreBtn.querySelector('[data-rpw-more-label]') || {}).textContent || 'Load 24 more';
    moreBtn.addEventListener('click', function () { state.page++; load(false); });
  }
  if (clearBtn) clearBtn.addEventListener('click', function () {
    state.photosOnly = false; state.catIds = null; state.query = ''; state.star = null;
    if (searchEl) searchEl.value = '';
    pills.forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
    Array.prototype.forEach.call(root.querySelectorAll('[data-rpw-bar]'), function (b) {
      b.setAttribute('aria-pressed', 'false');
    });
    syncUrl();
    load(true);
  });

  /* "See all photos" opens the gallery rather than only filtering the wall,
     which is what the button says it does. */
  root.addEventListener('click', function (e) {
    if (!e.target.closest('[data-rpw-see-photos]')) return;
    openGallery();
  });

  /* ── gallery ──────────────────────────────────────────────────────────
     One dialog, two entry points: a mosaic tile opens the store-wide photo
     feed, a photo on a review card opens the photos among the reviews already
     on screen. Paging past the end of the loaded feed fetches the next page,
     so "+708 more" is a real doorway rather than a label. */
  var photos = { items: [], total: 0, page: 1, loading: false };
  var lb = root.querySelector('[data-rpw-lightbox]');
  var lbImg = root.querySelector('[data-rpw-lb-img]');
  var gallery = { list: [], index: 0, source: 'photos' };
  var lastFocus = null;

  function lbFill() {
    var r = gallery.list[gallery.index];
    if (!r) return;
    var res = (r.resources || [])[0] || {};
    var q = function (sel) { return root.querySelector(sel); };

    lbImg.src = res.src || '';
    lbImg.alt = r.content ? String(r.content).slice(0, 120) : 'Customer photo';
    q('[data-rpw-lb-stars]').innerHTML = stars(r.star);
    q('[data-rpw-lb-date]').textContent = niceDate(r.commented_at);
    q('[data-rpw-lb-text]').textContent = r.content || '';
    q('[data-rpw-lb-avatar]').textContent = initials(r.author);
    q('[data-rpw-lb-author]').textContent = r.author || 'Anonymous';
    q('[data-rpw-lb-verified]').hidden = !Number(r.verified_badge);

    var piece = q('[data-rpw-lb-piece]');
    var prod = r.corresponding_product;
    if (prod && prod.product_name) {
      piece.hidden = false;
      piece.href = prod.product_url || '#';
      q('[data-rpw-lb-piece-name]').textContent = prod.product_name;
      var pim = q('[data-rpw-lb-piece-img]');
      if (prod.product_image) { pim.src = prod.product_image; pim.hidden = false; } else { pim.hidden = true; }
    } else { piece.hidden = true; }

    var total = gallery.source === 'photos' ? photos.total : gallery.list.length;
    q('[data-rpw-lb-index]').textContent = 'Photo ' + num(gallery.index + 1) + ' of ' + num(total);
    q('[data-rpw-lb-prev]').disabled = gallery.index === 0;
    q('[data-rpw-lb-next]').disabled = gallery.index >= gallery.list.length - 1 &&
      (gallery.source !== 'photos' || gallery.list.length >= photos.total);

    /* the strip is a window onto the stream, centred on where you are */
    var strip = q('[data-rpw-lb-strip]');
    var from = Math.max(0, Math.min(gallery.index - 2, gallery.list.length - 6));
    var slice = gallery.list.slice(from, from + 6);
    strip.innerHTML = slice.map(function (x, k) {
      var i = from + k;
      var src = ((x.resources || [])[0] || {}).thumb || ((x.resources || [])[0] || {}).src || '';
      return '<button type="button" class="rpw-lb-thumb" data-rpw-lb-jump="' + i + '"' +
             (i === gallery.index ? ' aria-current="true"' : '') +
             ' aria-label="Photo ' + (i + 1) + '"><img src="' + esc(src) + '" alt="" loading="lazy"></button>';
    }).join('');
  }

  function morePhotos() {
    if (photos.loading || photos.items.length >= photos.total) return Promise.resolve();
    photos.loading = true;
    return fetch(REVIEWS + '?shop_id=' + encodeURIComponent(SHOP) +
      '&scene=1&is_show_all=1&is_buyers_show=2&has_resource=1&no_empty=2&limit=24&page=' +
      (photos.page + 1) + '&sort_by=commented-at-descending', { headers: { accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (jn) {
        var add = ((jn && jn.data && jn.data.list) || []).filter(function (r) { return (r.resources || []).length; });
        photos.page++;
        photos.items = photos.items.concat(add);
        if (gallery.source === 'photos') gallery.list = photos.items;
      })
      .catch(function () {})
      .finally(function () { photos.loading = false; });
  }

  function lbOpen(list, index, source) {
    if (!list.length) return;
    gallery.list = list; gallery.index = index; gallery.source = source || 'photos';
    lastFocus = document.activeElement;
    lb.hidden = false;
    document.body.classList.add('rpw-lb-open');
    lbFill();
    root.querySelector('[data-rpw-lb-close]').focus();
  }
  function lbClose() {
    lb.hidden = true;
    document.body.classList.remove('rpw-lb-open');
    lbImg.removeAttribute('src');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function lbStep(dir) {
    var next = gallery.index + dir;
    if (next < 0) return;
    if (next >= gallery.list.length) {
      if (gallery.source !== 'photos') return;
      return morePhotos().then(function () {
        if (next < gallery.list.length) { gallery.index = next; lbFill(); }
      });
    }
    gallery.index = next; lbFill();
    /* keep a page in hand so the next click never waits */
    if (gallery.source === 'photos' && gallery.index > gallery.list.length - 4) morePhotos();
  }

  /* Rule 2 on the flow board: one photo stream, not one per review. A photo on
     a card opens the store-wide gallery POSITIONED at that photo, so browsing
     never dead-ends inside a single review. Both feeds are newest-first, so the
     match is usually on the first page; give up after a few and open at the top
     rather than hanging. */
  /* The pill tile is the gallery's entry point, so it must not open the lightbox
     at photo five. */
  if (mosaic) mosaic.addEventListener('click', function (e) {
    var all = e.target.closest('.rpw-tile--all');
    if (!all) return;
    e.stopPropagation();
    openGallery();
  }, true);

  function openInStream(id) {
    var find = function () {
      for (var i = 0; i < photos.items.length; i++) {
        if (String(photos.items[i].id) === String(id)) return i;
      }
      return -1;
    };
    var at = find();
    if (at >= 0) { lbOpen(photos.items, at, 'photos'); return; }
    var tries = 0;
    var dig = function () {
      if (tries++ >= 3 || photos.items.length >= photos.total) {
        lbOpen(photos.items, Math.max(0, find()), 'photos');
        return;
      }
      morePhotos().then(function () {
        var k = find();
        if (k >= 0) lbOpen(photos.items, k, 'photos'); else dig();
      });
    };
    dig();
  }

  /* swipe, because the flow board asks for it by name */
  (function swipe() {
    var x0 = null, y0 = null;
    lb.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) lbStep(dx < 0 ? 1 : -1);
      x0 = y0 = null;
    }, { passive: true });
  })();

  root.addEventListener('click', function (e) {
    var tile = e.target.closest('[data-rpw-photo]');
    if (tile) { lbOpen(photos.items, parseInt(tile.getAttribute('data-rpw-photo'), 10) || 0, 'photos'); return; }

    var cardPhoto = e.target.closest('[data-rpw-card-photo]');
    if (cardPhoto) { openInStream(cardPhoto.getAttribute('data-rpw-card-photo')); return; }

    var jump = e.target.closest('[data-rpw-lb-jump]');
    if (jump) { gallery.index = parseInt(jump.getAttribute('data-rpw-lb-jump'), 10) || 0; lbFill(); return; }
    if (e.target.closest('[data-rpw-lb-close]')) { lbClose(); return; }
    if (e.target.closest('[data-rpw-lb-prev]')) { lbStep(-1); return; }
    if (e.target.closest('[data-rpw-lb-next]')) { lbStep(1); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (lb.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); lbClose(); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); lbStep(-1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); lbStep(1); }
    else if (e.key === 'Tab') {
      /* keep focus inside the dialog */
      var f = lb.querySelectorAll('button:not([disabled]), a[href]');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  readUrl();
  loadSummary();
  loadPhotos();
  load(true);

  /* ── ST7 · the photo gallery, node 901:107 ───────────────────────────────
     Ruthik: "when you see the gallery section that we want the same ... I need
     exactly same as Figma."

     It was opening ST1, the single-photo lightbox, at index 0. ST7 is a different
     frame doing a different job: a grid of every photo with its own category
     pills and its own Load more. Opening a tile from here hands off to ST1
     positioned at that photo, which is the one stream the flow board asks for. */
  var galleryEl = root.querySelector('[data-rpw-gallery]');
  var gGrid = root.querySelector('[data-rpw-gallery-grid]');
  var gMore = root.querySelector('[data-rpw-gallery-more]');
  var gShown = root.querySelector('[data-rpw-gallery-shown]');
  var gCount = root.querySelector('[data-rpw-gallery-count]');
  var gCat = '';

  function galleryRows() {
    if (!gCat) return photos.items;
    var ids = gCat.split(',');
    return photos.items.filter(function (r) {
      var pid = r.corresponding_product && String(r.corresponding_product.product_id);
      return pid && ids.indexOf(pid) !== -1;
    });
  }

  function paintGallery() {
    if (!gGrid) return;
    var rows = galleryRows();
    gGrid.innerHTML = rows.map(function (r, i) {
      var src = (r.resources || [])[0];
      if (!src || !src.src) return '';
      var who = (r.corresponding_product && r.corresponding_product.product_name) || 'Aykah';
      return '<button type="button" class="rpw-gtile" data-rpw-gtile="' + i + '">' +
             '<img src="' + esc(src.src) + '" alt="' + esc(who) + '" loading="lazy">' +
             '</button>';
    }).join('');

    if (gCount) {
      gCount.textContent = num(photos.total) + ' photos from ' + num(state.totalCount) + ' reviews';
    }
    if (gShown) {
      gShown.textContent = num(rows.length) + ' of ' + num(gCat ? rows.length : photos.total) + ' shown';
      gShown.hidden = !rows.length;
    }
    /* A category filters what is already here, so there is nothing further to
       fetch for it; only the unfiltered gallery can go deeper. */
    if (gMore) gMore.hidden = !!gCat || photos.items.length >= photos.total;

    Array.prototype.forEach.call(gGrid.querySelectorAll('[data-rpw-gtile]'), function (tile) {
      tile.addEventListener('click', function () {
        var i = Number(tile.getAttribute('data-rpw-gtile')) || 0;
        var row = galleryRows()[i];
        var at = photos.items.indexOf(row);
        closeGallery();
        lbOpen(photos.items, at < 0 ? 0 : at, 'photos');
      });
    });
  }

  function openGallery() {
    if (!galleryEl) return;
    galleryEl.hidden = false;
    document.documentElement.classList.add('rpw-locked');
    paintGallery();
  }
  function closeGallery() {
    if (!galleryEl) return;
    galleryEl.hidden = true;
    document.documentElement.classList.remove('rpw-locked');
  }

  var gClose = root.querySelector('[data-rpw-gallery-close]');
  if (gClose) gClose.addEventListener('click', closeGallery);
  if (galleryEl) galleryEl.addEventListener('click', function (e) {
    if (e.target === galleryEl) closeGallery();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && galleryEl && !galleryEl.hidden) closeGallery();
  });

  Array.prototype.forEach.call(root.querySelectorAll('[data-rpw-gpill]'), function (pill) {
    pill.addEventListener('click', function () {
      gCat = pill.getAttribute('data-rpw-gpill') || '';
      Array.prototype.forEach.call(root.querySelectorAll('[data-rpw-gpill]'), function (p2) {
        p2.setAttribute('aria-pressed', p2 === pill ? 'true' : 'false');
      });
      paintGallery();
    });
  });

  if (gMore) gMore.addEventListener('click', function () {
    var spin = gMore.querySelector('[data-rpw-gallery-spin]');
    var label = gMore.querySelector('[data-rpw-gallery-more-label]');
    if (spin) spin.hidden = false;
    if (label) label.textContent = 'Loading';
    gMore.disabled = true;
    morePhotos().then(function () {
      if (spin) spin.hidden = true;
      if (label) label.textContent = 'Load 40 more photos';
      gMore.disabled = false;
      paintGallery();
    });
  });

  /* ── Write a review ──────────────────────────────────────────────────────
     Ruthik: "I can't able to write the review. It is redirecting me to the
     different page."

     It was an <a> to ?req=review, which only means anything on a product page,
     so from here it just left. Trustoo's own write-review window is a GLOBAL app
     embed and is already present on this page, verified in the live DOM, so the
     button opens that instead of going anywhere. The href stays as the fallback
     for a browser with no JS, which is the only case where leaving is better than
     doing nothing. */
  function openTrustooWriteForm() {
    var trigger = document.querySelector('.tt-write-reviews');
    if (!trigger) return false;
    trigger.click();
    return true;
  }

  /* These are buttons now, not links, so nothing can navigate. The previous
     version fell back to ?req=review when Trustoo was missing, which is how a
     click ended up leaving the page entirely: that query only means something on
     a product page, and Trustoo's app embed is not enabled on every theme.

     A popup opens either way. If Trustoo's window is on the page it is used,
     because that is the same form the product page uses and the only thing that
     actually submits. If it is not, the shopper gets told that in a panel rather
     than being thrown somewhere unrelated. */
  var writeFallback = root.querySelector('[data-rpw-write-fallback]');

  function openWritePanel() {
    if (!writeFallback) return;
    writeFallback.hidden = false;
    document.documentElement.classList.add('rpw-locked');
  }
  function closeWritePanel() {
    if (!writeFallback) return;
    writeFallback.hidden = true;
    document.documentElement.classList.remove('rpw-locked');
  }
  var wfClose = root.querySelector('[data-rpw-write-close]');
  if (wfClose) wfClose.addEventListener('click', closeWritePanel);
  if (writeFallback) writeFallback.addEventListener('click', function (e) {
    if (e.target === writeFallback) closeWritePanel();
  });

  Array.prototype.forEach.call(root.querySelectorAll('[data-rpw-write]'), function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (!openTrustooWriteForm()) openWritePanel();
    });
  });
})();
